import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { GetPlaces } from '../component/places/places.component';
import { MarkerPlaces } from '../component/places/marker.places.component';
import Search from '../../../components/Map/Search';

import { ProfileContext } from '../../../services/profile/profile.context';
import { UserPreferLocation } from '../component/user/user.component';

const useStyle = makeStyles((theme) => {
  return {
    mapContainer: {
      height: 320,
    },
    memberIcon: {
      borderRadius: '50%',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  };
});

const PreferLocation = ({ setError }) => {
  const classes = useStyle();
  const { user } = useContext(ProfileContext);

  return (
    <Box boxShadow={3} height={300}>
      <MapContainer
        className={classes.mapContainer}
        center={[29.62316571303948, 52.523923516273506]}
        minZoom={1}
        zoom={15}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright"></a> contributors'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />

        <ZoomControl position='topright' />
        <GetPlaces />
        <MarkerPlaces />
        {user && <UserPreferLocation setError={setError} />}
        <Search />
      </MapContainer>
    </Box>
  );
};

export default PreferLocation;
